import { Dispatch, SetStateAction } from 'react';

import {
  getMyHubsGoldenCardAsync,
  getMyHubsSubscriptionsAsync,
  getMyHubsSubscriptionsBundleAsync,
  getMyHubsSummaryAsync,
  getMyHubsSuperSalesAsync,
  getMyHubsTravelAsync,
  getMyHubsVipAsync,
  sendGiftAsync
} from './Portfolio.requests';

import { createAsyncThunk } from '@reduxjs/toolkit';
import { SendGiftSteps } from './Subscriptions/Subscription.types';
import { ErrorToast } from '../../components';

export const getMyHubsSummary = createAsyncThunk(
  'getMyHubsSummary',
  async () => {
    const { data } = await getMyHubsSummaryAsync();

    return data;
  }
);

export const getMyHubsTravel = createAsyncThunk('getMyHubsTravel', async () => {
  const { data } = await getMyHubsTravelAsync();
  return data;
});

export const getMyHubsSubscriptions = createAsyncThunk(
  'getMyHubsSubscriptions',
  async () => {
    const { data } = await getMyHubsSubscriptionsAsync();
    return data.orders;
  }
);

export const getMyHubsSubscriptionsBundle = createAsyncThunk(
  'getMyHubsSubscriptionsBundle',
  async () => {
    const { data } = await getMyHubsSubscriptionsBundleAsync();
    return data.orders;
  }
);

export const getMyHubsSuperSales = createAsyncThunk(
  'getMyHubsSuperSales',
  async () => {
    const { data } = await getMyHubsSuperSalesAsync();
    return data;
  }
);

export const getMyHubsVip = createAsyncThunk('getMyHubsVip', async () => {
  const { data } = await getMyHubsVipAsync();
  return data;
});

export const sendGift = createAsyncThunk(
  'sendGift',
  async ({
    giftOrderId,
    recipientUserId,
    setStep
  }: {
    giftOrderId: number;
    recipientUserId: string;
    setStep: Dispatch<SetStateAction<SendGiftSteps>>;
  }) => {
    try {
      const { data } = await sendGiftAsync({ giftOrderId, recipientUserId });

      setStep(SendGiftSteps.SUCCESS);
      return {
        giftOrderId,
        giftedTravelutionSubscription: data?.giftedTravelutionSubscription
      };
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);

export const getMyHubsGoldenCard = createAsyncThunk(
  'getMyHubsGoldenCard',
  async () => {
    const { data } = await getMyHubsGoldenCardAsync();

    return data;
  }
);
